import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { PdfExportDomain } from '@mode/shared/contract-common';
// import {  } from 'rxjs';
import { combineLatest, filter, Observable, Subject } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';
import { PdfExportDialogService } from './pdf-export-dialog-service';

@Component({
  selector: 'mode-pdf-export-dialog',
  templateUrl: './pdf-export-dialog.component.html',
  styleUrls: ['./pdf-export-dialog.component.scss'],
})
export class PdfExportDialogComponent implements OnInit {
  @Output() pdfIsGenerating = new EventEmitter<void>();
  @Output() pdfGenerationSuccess = new EventEmitter<void>();
  @Output() pdfGenerationFailed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
  @Output() pdfDownloaded = new EventEmitter<void>();

  public pdfExport: PdfExportDomain.PdfExport | null = null;
  public statusText$!: Observable<string>;
  public showCancel = false;
  public downloadLink$!: Observable<string | null>;
  public loading$!: Observable<boolean>;
  public success$!: Observable<boolean>;
  public error$!: Observable<Error | null>;

  public hasError$ = new Subject<void>();

  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA)
    public data: {
      job: PdfExportDomain.PdfExportJob;
    },
    private pdfExportDialogService: PdfExportDialogService
  ) {}

  ngOnInit(): void {
    this.downloadLink$ = this.data.job.link$;
    this.loading$ = combineLatest([this.data.job.complete$, this.data.job.error$]).pipe(
      map(([complete, error]) => !complete && error == null),
      tap((isLoading: boolean) => isLoading && this.pdfIsGenerating.emit())
    );

    this.success$ = combineLatest([this.data.job.complete$, this.data.job.error$]).pipe(
      takeUntil(this.hasError$),
      map(([complete, error]) => complete && error == null),
      tap((success: boolean) => success && this.pdfGenerationSuccess.emit())
    );

    this.error$ = this.data.job.error$.pipe(
      filter((error) => !!error),
      tap(() => {
        this.hasError$.next();
        this.hasError$.complete();
        this.pdfGenerationFailed.emit();
      })
    );

    this.statusText$ = combineLatest([this.data.job.complete$, this.data.job.error$]).pipe(
      map(([complete, error]) => {
        if (error) {
          return 'PDF file failed to generate';
        }

        if (complete) {
          return 'PDF file is ready for download';
        } else {
          return 'Generating PDF...';
        }
      })
    );
  }

  downloadPDF() {
    this.downloadLink$.pipe(filter((link: string | null) => !!link)).subscribe((link: string | null) => {
      this.pdfDownloaded.emit();
      if (link) {
        window.location.href = link;
      }
    });
  }

  dismiss() {
    this.cancelled.emit();
    this.pdfExportDialogService.close();
  }
}
